import React from "react";
import UsersListPanel from "./UsersListPanel";
import Modal from "./UsersModal";
import useUsersLoad from "./useUsersLoad";
import Select from "./UsersSelect";
import Swal from "sweetalert2";
import { Button, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
import { getAllClient } from "stores";
import { useDispatch, useSelector } from "react-redux";

import { tambahKorcab } from "stores";
import { getAllKorcab } from "stores";
import { getAllCabang } from "stores";
import { penempatanKorcab } from "stores";
import { settingMenuKorcab } from "stores";

function ListBPD() {
  const dispatch = useDispatch();
  const listState = useUsersLoad(getAllKorcab, dispatch);
  const [selectedUser, setSelectedUser] = React.useState(null);
  const storeClient = useSelector((state) => state.clientReducer);
  const korcab = useSelector((state) => state.korcabReducer);
  const storeCabang = useSelector((state) => state.cabangReducer);

  const auth = useSelector((state) => state.authReducer);

  const [listKorcab, setListKorcab] = React.useState([]);
  const [pilihClient, setPilihClient] = React.useState(null);
  const [idClient, setIdClient] = React.useState("");
  const [modalKorcab, setModalKorcab] = React.useState(false);
  const [modalSettingMenu, setModalSettingMenu] = React.useState(false);
  const [modalPenempatan, setModalPenempatan] = React.useState(false);
  const [nama, setNama] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [listClient, setListClient] = React.useState([]);

  const [isLoading, setIsLoading] = React.useState(true);
  const [listCabang, setListCabang] = React.useState([]);
  const [idCabang, setIdCabang] = React.useState(null);
  const [pilihCabang, setPilihCabang] = React.useState(null);
  const [idKorcab, setIdKorcab] = React.useState("");
  const [listDetailCabang, setListDetailCabang] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [multipleSelect, setMultipleSelect] = React.useState([]);
  const [idWilayah, setIdWilayah] = React.useState({
    label: "",
    value: "",
  });

  const submitSettingMenu = () => {
    const dataToSend = {
      idKorcab: idKorcab,
      menu: multipleSelect.map((option) => option.value),
    };
    settingMenuKorcab(dataToSend)
      .then((response) => {
        if (response.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          getAllKorcab(dispatch);
          setModalSettingMenu(false);
        } else if (response.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: error.message,
        });
      });
  };

  const submitKorcab = () => {
    tambahKorcab({
      nama: nama,
      email: email,
      idClient: idClient,
    })
      .then((response) => {
        // console.log(response);
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            showConfirmButton: false,
            title: response.data.message,
            timer: 1000,
          });
          handleModalClose();
          getAllKorcab(dispatch);
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log("ERRORRRR", error);
      });
  };

  const submitPenempatan = () => {
    if (pilihCabang === null) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Pemilihan Cabang tidak boleh kosong",
      });
    } else {
      penempatanKorcab({
        idKorcab: idKorcab,
        idCabang: idCabang,
      }).then((response) => {
        if (response.data.status === 200) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: response.data.message,
            showConfirmButton: false,
            timer: 1000,
          });
          handleModalClose();
          // setIdCabang("");
          // setPilihCabang("");
          getAllKorcab(dispatch);
        } else if (response.data.status === 400) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      });
    }
  };

  const handleModalClose = () => {
    setModalKorcab(false);
    setPilihClient(null);
    setNama("");
    setEmail("");
    setIdClient("");
    setPilihCabang(null);
    setIdCabang(null);
    setModalPenempatan(false);
  };

  React.useEffect(() => {
    let tmp =
      korcab.listKorcab &&
      korcab.listKorcab.map((val) => {
        return {
          ...val,
          action: (
            <>
              <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                {auth.role === "super admin" || auth.role === "admin" ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Penempatan Korcab</Tooltip>}
                  >
                    <Button aria-label="Penempatan Korcab" title="Penempatan Korcab"
                      disabled={val.status !== "aktif"}
                      variant="light"
                      style={{
                        padding: "8px",
                        borderRadius: "8px",
                        backgroundColor: val.status !== "aktif" ? "#F1F5F9" : "#EFF6FF",
                        color: val.status !== "aktif" ? "#94A3B8" : "#3B82F6",
                        border: "none",
                        boxShadow: val.status !== "aktif" ? "none" : "0 2px 4px rgba(0,0,0,0.05)",
                        transition: "all 0.2s",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "36px",
                        height: "36px",
                        cursor: val.status !== "aktif" ? "not-allowed" : "pointer",
                      }}
                      onMouseEnter={(e) => {
                        if (val.status === "aktif") {
                          e.currentTarget.style.backgroundColor = "#3B82F6";
                          e.currentTarget.style.color = "#FFFFFF";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (val.status === "aktif") {
                          e.currentTarget.style.backgroundColor = "#EFF6FF";
                          e.currentTarget.style.color = "#3B82F6";
                        }
                      }}
                      onClick={() => {
                        setSelectedUser(val);
                      setIdKorcab(val._id);
                        setPilihCabang(null);
                      setIdCabang(null);
                      getAllCabang(dispatch, { idClient: val.idClient });
                        setModalPenempatan(!modalPenempatan);
                      }}
                    >
                      <i className="fas fa-map-marker-alt"></i>
                    </Button>
                  </OverlayTrigger>
                ) : (
                  "-"
                )}

                {auth.role === "super admin" ? (
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip>Setting Menu</Tooltip>}
                  >
                    <Button aria-label="Setting Menu" title="Setting Menu"
                      variant="light"
                      style={{
                        padding: "8px",
                        borderRadius: "8px",
                        backgroundColor: "#FDF4FF",
                        color: "#C026D3",
                        border: "none",
                        boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
                        transition: "all 0.2s",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "36px",
                        height: "36px",
                        cursor: "pointer",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = "#C026D3";
                        e.currentTarget.style.color = "#FFFFFF";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "#FDF4FF";
                        e.currentTarget.style.color = "#C026D3";
                      }}
                      onClick={() => {
                        setModalSettingMenu(!modalSettingMenu);
                        setSelectedUser(val);
                      setIdKorcab(val._id);
                      }}
                    >
                      <i className="fas fa-user-cog"></i>
                    </Button>
                  </OverlayTrigger>
                ) : null}
              </div>
            </>
          ),
        };
      });
    setListKorcab(tmp);
  }, [korcab.listKorcab, auth]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeClient.listClient &&
      storeClient.listClient.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaClient,
        });
      });
    setListClient(tmp);
  }, [storeClient.listClient]);

  React.useEffect(() => {
    let tmp = [
      {
        value: "",
        isDisabled: true,
      },
    ];
    storeCabang.listCabang &&
      storeCabang.listCabang.map((val) => {
        tmp.push({
          value: val._id,
          label: val.namaCabang,
        });
      });
    // console.log(tmp, "TMPPPPP");
    setListCabang(tmp);
  }, [storeCabang.listCabang]);

  const getStatusUser = (statusUser) => {
    switch (statusUser) {
      case "tidak aktif":
        return {
          backgroundColor: "#FEE2E2",
          textColor: "#DC2626",
          icon: "fas fa-times-circle"
        };
      case "aktif":
        return {
          backgroundColor: "#DCFCE7",
          textColor: "#16A34A",
          icon: "fas fa-check-circle"
        };
      default:
        return {
          backgroundColor: "#F1F5F9",
          textColor: "#64748B",
          icon: "fas fa-info-circle"
        };
    }
  };

  const colKorcab = [
    {
      name: "No",
      width: "80px",
      center: true,
      selector: (row, index) => index + 1,
    },
    {
      name: "Aksi",
      minWidth: "150px",
      center: true,
      selector: (row) => row.action,
    },
    {
      name: "Kode User",
      minWidth: "200px",
      center: true,
      selector: (row) => row.kodeUser,
    },
    {
      name: "Nama",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nama,
    },
    {
      name: "Username",
      minWidth: "200px",
      center: true,
      selector: (row) => row.nopeg,
    },
    {
      name: "Role",
      minWidth: "200px",
      center: true,
      selector: (row) => row.role,
    },
    {
      name: "Status",
      minWidth: "150px",
      center: true,
      // selector: (row) => (row.status === "aktif" ? "Aktif" : "Tidak Aktif"),
      selector: (row) => row.status,
      cell: (row) => {
        const statusStyle = getStatusUser(row.status);
        const tampilanLabel = row.status === "aktif" ? "Aktif" : "Tidak Aktif";

        return (
          <div
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "6px",
              fontWeight: "600",
              backgroundColor: statusStyle.backgroundColor,
              color: statusStyle.textColor,
              padding: "6px 12px",
              borderRadius: "20px",
              fontSize: "12px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
            }}
          >
            <i className={statusStyle.icon}></i>
            {tampilanLabel}
          </div>
        );
      },
    },
    {
      name: "Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) =>
        !row.penempatan?.length || (row.penempatan.length === 1 && !row.penempatan[0]?.namaCabang) ? (
          <div style={{ fontWeight: "bold" }}>Belum Penempatan</div>
        ) : row.penempatan.length === 1 ? (
          row.penempatan?.[0]?.namaCabang
        ) : (
          <>
            <div>{row.penempatan?.[0]?.namaCabang},...</div>
            <button type="button" className="users-branch-link"
              onClick={() => {
                setSelectedUser(row);
                setListDetailCabang(row);
                setModalDetail(true);
                // console.log(row);
              }}
            >Lihat semua cabang</button>
          </>
        ),
    },
  ];

  React.useEffect(() => {
    getAllCabang(dispatch, { idWilayah: idWilayah.value })
      .then(() => {
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
    getAllClient(dispatch);
  }, [idWilayah]);

  React.useEffect(() => { getAllClient(dispatch); }, [dispatch]);

  return (
    <>
      <Modal
        size="lg"
        show={modalSettingMenu}
        onHide={() => setModalSettingMenu(!modalSettingMenu)}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#FDF4FF", padding: "8px", borderRadius: "10px", color: "#C026D3", display: "flex" }}>
                <i className="fas fa-list-ul"></i>
              </div>
              Setting Menu
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalSettingMenu(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form.Group>
              <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Menu Akses</label>
              <Select
                classNamePrefix="react-select"
                placeholder="Pilih Menu..."
                closeMenuOnSelect={false}
                isMulti
                value={multipleSelect}
                onChange={(value) => setMultipleSelect(value)}
                options={[
                  { value: "Dashboard", label: "Dashboard" },
                  { value: "Client", label: "Client" },
                  { value: "User", label: "User" },
                  { value: "Cabang", label: "Cabang" },
                  { value: "Target", label: "Target" },
                  { value: "Pengajuan", label: "Pengajuan" },
                  { value: "Pencairan", label: "Pencairan" },
                  { value: "Kunjungan", label: "Kunjungan" },
                  { value: "ListKunjungan", label: "List Kunjungan" },
                ]}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "10px",
                    borderColor: "#E2E8F0",
                    padding: "4px",
                    boxShadow: "none",
                    "&:hover": { borderColor: "#C026D3" }
                  })
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalSettingMenu(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitSettingMenu}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#C026D3", border: "none", boxShadow: "0 4px 6px rgba(192, 38, 211, 0.2)", color: "white" }}
            >
              Simpan Menu
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#F1F5F9", padding: "8px", borderRadius: "10px", color: "#64748B", display: "flex" }}>
                <i className="fas fa-info-circle"></i>
              </div>
              Detail Penempatan
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalDetail(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "0" }}>
            <div style={{ padding: "24px", borderBottom: "1px solid #F1F5F9" }}>
              <div style={{ display: "flex", marginBottom: "16px" }}>
                <div style={{ width: "120px", color: "#64748B", fontWeight: "600", fontSize: "14px" }}>Nama</div>
                <div style={{ color: "#1E293B", fontWeight: "600", fontSize: "14px" }}>: {listDetailCabang.nama}</div>
              </div>
              <div style={{ display: "flex" }}>
                <div style={{ width: "120px", color: "#64748B", fontWeight: "600", fontSize: "14px" }}>Username</div>
                <div style={{ color: "#1E293B", fontWeight: "600", fontSize: "14px" }}>: {listDetailCabang.nopeg}</div>
              </div>
            </div>
            <div style={{ padding: "24px", backgroundColor: "#F8FAFC" }}>
              <h6 style={{ color: "#475569", fontWeight: "700", fontSize: "13px", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "12px" }}>Daftar Penempatan Cabang</h6>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {listDetailCabang.penempatan &&
                  listDetailCabang.penempatan.map((val, idx) => (
                    <div key={idx} style={{ display: "flex", alignItems: "center", gap: "10px", backgroundColor: "#FFFFFF", padding: "10px 16px", borderRadius: "8px", border: "1px solid #E2E8F0" }}>
                      <i className="fas fa-map-marker-alt" style={{ color: "#3B82F6" }}></i>
                      <span style={{ color: "#1E293B", fontWeight: "500", fontSize: "14px" }}>{val.namaCabang}</span>
                    </div>
                  ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#FFFFFF" }}>
            <Button
              variant="light"
              onClick={() => setModalDetail(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "8px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Tutup
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalPenempatan}
        onHide={() => {
          handleModalClose();
          setModalPenempatan(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={selectedUser}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#EFF6FF", padding: "8px", borderRadius: "10px", color: "#3B82F6", display: "flex" }}>
                <i className="fas fa-map-marker-alt"></i>
              </div>
              Form Penempatan BPD
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalPenempatan(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form.Group>
              <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Cabang</label>
              <Select
                classNamePrefix="react-select"
                placeholder="Pilih Cabang..."
                closeMenuOnSelect={false}
                isMulti
                value={pilihCabang}
                onChange={(values) => {
                  setPilihCabang(values);
                  const ids = values ? values.map((item) => item.value) : [];
                  setIdCabang(ids);
                }}
                options={listCabang}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "10px",
                    borderColor: "#E2E8F0",
                    padding: "4px",
                    boxShadow: "none",
                    "&:hover": { borderColor: "#3B82F6" }
                  })
                }}
              />
            </Form.Group>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalPenempatan(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitPenempatan}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", backgroundColor: "#3B82F6", border: "none", boxShadow: "0 4px 6px rgba(59, 130, 246, 0.2)", color: "white" }}
            >
              Simpan Penempatan
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <Modal
        size="md"
        show={modalKorcab}
        onHide={() => {
          handleModalClose();
          setModalKorcab(false);
        }}
        centered
        contentClassName="luxury-modal"
        selectedUser={null}
      >
        <>
          <Modal.Header style={{ borderBottom: "1px solid #E2E8F0", padding: "20px 24px", backgroundColor: "#F8FAFC" }}>
            <Modal.Title style={{ color: "#1E293B", fontWeight: "700", fontSize: "18px", margin: 0, display: "flex", alignItems: "center", gap: "10px" }}>
              <div style={{ backgroundColor: "#F0FDF4", padding: "8px", borderRadius: "10px", color: "#16A34A", display: "flex" }}>
                <i className="fas fa-user-plus"></i>
              </div>
              Form Tambah Koordinator Cabang (BPD)
            </Modal.Title>
            <button aria-label="Tutup dialog" type="button" className="close" onClick={() => setModalKorcab(false)} style={{ color: "#64748B", opacity: 1, fontSize: "24px" }}>&times;</button>
          </Modal.Header>
          <Modal.Body style={{ padding: "24px" }}>
            <Form>
              <Form.Group className="mb-4">
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Nama Lengkap</label>
                <Form.Control
                  onChange={(e) => setNama(e.target.value)}
                  placeholder="Masukkan nama lengkap"
                  type="text"
                  style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                />
              </Form.Group>
              <Form.Group className="mb-4">
                <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Username</label>
                <Form.Control
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Masukkan username"
                  type="text"
                  style={{ borderRadius: "10px", padding: "12px 16px", border: "1px solid #E2E8F0" }}
                />
              </Form.Group>
              {auth.role === "super admin" && (
                <Form.Group className="mb-4">
                  <label style={{ color: "#475569", fontWeight: "600", fontSize: "14px", marginBottom: "8px" }}>Pilih Client</label>
                  <Select
                    classNamePrefix="react-select"
                    value={pilihClient}
                    onChange={(value) => {
                      setPilihClient(value);
                      setIdClient(value.value);
                    }}
                    options={listClient}
                    placeholder="Pilih Client..."
                    styles={{
                      control: (base) => ({
                        ...base,
                        borderRadius: "10px",
                        borderColor: "#E2E8F0",
                        padding: "2px",
                        boxShadow: "none",
                        "&:hover": { borderColor: "#16A34A" }
                      })
                    }}
                  />
                </Form.Group>
              )}
            </Form>
          </Modal.Body>
          <Modal.Footer style={{ borderTop: "1px solid #E2E8F0", padding: "16px 24px", backgroundColor: "#F8FAFC" }}>
            <Button
              variant="light"
              onClick={() => setModalKorcab(false)}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 20px", color: "#64748B", border: "1px solid #E2E8F0" }}
            >
              Batal
            </Button>
            <Button
              onClick={submitKorcab}
              style={{ borderRadius: "8px", fontWeight: "600", padding: "10px 24px", backgroundColor: "#16A34A", border: "none", boxShadow: "0 4px 6px rgba(22, 163, 74, 0.2)", color: "white" }}
            >
              <i className="fas fa-save mr-2"></i> Simpan Data
            </Button>
          </Modal.Footer>
        </>
      </Modal>

      <UsersListPanel title="BPD" description="Kelola akun BPD, penempatan cabang, dan menu yang dapat diakses."
        data={listKorcab} columns={colKorcab} {...listState}
        addLabel="Tambah BPD" onAdd={(auth.role === "super admin" || auth.role === "admin") ? () => setModalKorcab(true) : undefined} />

    </>
  );
}

export default ListBPD;
